"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProposalForm_component_1 = require("./ProposalForm.component");
exports.ProposalForm = ProposalForm_component_1.ProposalForm;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9Qcm9wb3NhbEZvcm0vaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxtRUFBcUQ7QUFBN0MsZ0RBQUEsWUFBWSxDQUFBIn0=